import { IonIcon } from '@ionic/react';

import logo from '../../theme/logos/logo.svg';
import classes from './Logo.module.css';

const Logo = () => {
    return <IonIcon src={logo} className={classes.Logo}></IonIcon>;
};

export default Logo;
